import React, {useState, useEffect} from 'react';
import axios from 'axios';
import ConsoHead from '../../components/header/ConsoHead';
import ShopNavbar from '../../components/header/ShopNavbar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ConsoFooter from '../../components/footer/ConsoSmallFooter';
import styles from '../../components/styles/rca/rca.module.scss';
import LoginPromo from '../../components/lead/LoginPromo';
import withFullPopup from '../../components/elements/withFullPopup';
import LoginBlock from '../../components/login/LoginBlock';
import { fetchProfile } from '../../components/login/userSlice';
import RCACarFlow from '../../components/rca/search/RCACarFlow';
import { getCookie, setPHPCookie, getCookieFromString } from '../../components/cookie/cookieTools';
import { loadCartFromStorage } from '../../components/utils/general/cartUtils';
import { useSelector, useDispatch } from 'react-redux';
import {saveProducts} from '../../components/cart/cartSlice';
import { accountMenuList, accountLogoffMenuList } from '../../components/header/mainMenuList';

const RCAShop = (props) =>{
    
    const {CSRFToken, phpCookie} = props;
    const [showLogin, editShowLogin] = useState(false);
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);

    const cart = useSelector(state => state.cart.products);

    useEffect(
        ()=>{
            let cookie = getCookie('PHPSESSID');
            if (!cookie && phpCookie) {
                setPHPCookie(phpCookie[0]);
            }
            setupCart();
        }, []
    )

    useEffect ( ()=>{
        if (user.isLoggedIn) {
            dispatch(fetchProfile());
            editShowLogin(false);
        }
        }, [user.isLoggedIn]
    )

    const setupCart = () => {
        if (cart && cart.length == 0) {
            const storageData = loadCartFromStorage();
            if (storageData && storageData.products) {
                dispatch(saveProducts({ products: storageData.products, status: 'init'}));
            }
        }
    }
   

    const seo  = {
        title: "Asigurări RCA - Compari și cumperi online",
        description: "Asigurări RCA: compari ofertele, alegi asigurarea cea mai bună și cumperi online. Primești polița electronică pe loc și îți livrăm documentele în format fizic la domiciliu.",
        canonical: process.env.NEXT_PUBLIC_SITE_URL + '/asigurari-rca'
    };

    const closeLogin = () => {editShowLogin(false)}
    const LoginScreen = withFullPopup(LoginBlock);
 
    return (
         <>
            <ConsoHead seo={seo} />
            <ShopNavbar
                menu={user.isLoggedIn ? accountMenuList : accountLogoffMenuList}
                selected=""
                cart={cart}
            />
            <div className="mb-0 pb-0 bg-home" id="main" >
                <Container>
                    <Row>
                        <Col  xs={12} lg={8} className="mx-auto text-center">
                            <h1 className="heading1 pt-3 font-weight-bold black-text pb-0 mb-0">
                                Asigurări RCA - Comparații
                            </h1>
                            <p className={styles.info}>
                                Completezi datele din talonul auto și compari rapid ofertele de asigurări RCA
                            </p>
                            
                        </Col>     
                    </Row>
                    <Row>
                        <Col xs={12} lg={8} className="mx-auto">
                            
                            { showLogin && 
                                <LoginScreen
                                    redirectUrl={false}
                                    openAccountLink={false}
                                    closePopup={closeLogin}
                                    title="Asigurari RCA"
                                    lg={6}
                                /> 
                            }

                            {!user.isLoggedIn && 
                            <div className={`${styles.boxWrapper} mb-5`} >
                                <LoginPromo goToLogin={editShowLogin} />
                            </div>
                            }
                            <RCACarFlow 
                                CSRFToken={CSRFToken}
                            />
                            
                        </Col>
                    </Row>
                </Container>
            </div>   
            <ConsoFooter />
        </>
    );
}

export default RCAShop;

export async function getServerSideProps(context) {

    const url = process.env.NEXT_PUBLIC_ENDAPI + '/secure/token';
    let CSRFToken = null;
    let phpCookie = false;

    let userCookie = context.req.headers.cookie ? getCookieFromString('PHPSESSID', context.req.headers.cookie ) : null;
    try {
        const response = await axios({
            method: 'get', 
            url: url, 
            headers: {'Content-Type': 'application/json', Cookie: context.req.headers.cookie ? context.req.headers.cookie : '' },
            withCredentials: true,
        });
        const data = response.data;
        
        if (data.status ) {
            CSRFToken = data.token;
            if (!userCookie) {
                phpCookie = response.headers['set-cookie'];
            }
        }
    } catch (err) {
    }

    return {
      props: {
          CSRFToken, 
          phpCookie,
      }, // will be passed to the page component as props
    }
  }

